module.exports = __webpack_public_path__ + "static/media/taipingshan_web.1add8e41.png";